import get from 'lodash/get';

export default function env(key: string, fallback: any) {
  return get(process.env, key, fallback);
}
